const { fetcher } = require('services/helpers/responseHandler')

const start = async ({ subscriberId, kind }) =>
  await fetcher.post('chat/start', { subscriberId, kind })

const create = async ({
  kind,
  guestFirstName,
  guestLastName,
  guestPhoneNumber,
  guestPhoneCountryCode = '1',
  roomNumber
}) =>
  await fetcher.post(`chat/${kind}/start`, {
    guestFirstName,
    guestLastName,
    guestPhoneNumber,
    guestPhoneCountryCode,
    roomNumber
  })

const generateSavibookLink = async ({ chatId, checkIn, overrideUrl }) =>
  await fetcher.get('chat/retrieve/agent/shortlink', { chatId, checkIn, overrideUrl })

const getHelpContent = async () => await fetcher.get('chat/helpContents')

const updateHelpContent = async ({ title, titleUndefinedMessage, contents }) =>
  await fetcher.post('chat/helpContentsUpdate', {
    title,
    titleUndefinedMessage,
    contents
  })

const chatApi = {
  start,
  create,
  generateSavibookLink,
  getHelpContent,
  updateHelpContent
}

export default chatApi
